@if (state$ | async; as state) {
  <div class="facet-outer">
    <button class="heading" (click)="toggleGroup($event)" [attr.aria-expanded]="isExpanded" [attr.aria-label]="
         'productFacetNavigation.filterBy.name' | cxTranslate: { name: facet.name }
       ">
      {{ facet.name }}
      <cx-icon class="kb-facet-icon collapse-icon" [type]="collapseIcon"></cx-icon>
      <cx-icon class="kb-facet-icon expand-icon" [type]="expandIcon"></cx-icon>
    </button>
    <div>
      <ng-container>
        @for (value of facet.values | slice: 0:state.topVisible; track value) {
          <a #facetValue routerLink="./"
            (click)="FacetClick(value,this.facetTabName)" class="value" [class.selected]="value.selected"
            [cxFocus]="{ key: value.name }" (keydown.space)="openLink($any($event))"
            [attr.role]="facet.multiSelect ? 'checkbox' : null"
          [attr.aria-checked]="facet.multiSelect ? value.selected : null" attr.aria-label="{{
          'productFacetNavigation.ariaLabelItemsAvailable'
            | cxTranslate: { name: value.name, count: value.count }
        }}">
            <span class="facetValueName" aria-hidden="true">{{ value.name }}<span aria-hidden="true" class="count">{{
            value.count }}</span></span>
          </a>
        }
        <div class="more">
          @for (
            value of facet.values
            | slice: state.topVisible ?? 0:state.maxVisible
            ; track
            value) {
            <a #facetValue routerLink="./" (click)="FacetClick(value,this.facetTabName)" class="value"
              [class.selected]="value.selected" [cxFocus]="{ key: value.name }" (keydown.space)="openLink($any($event))">
              <span>{{ value.name }}<span class="count">{{ value.count }}</span></span>
            </a>
          }
          @if (
            state.maxVisible &&
            state.topVisible &&
            state.maxVisible > state.topVisible
            ) {
<button (click)="decreaseVisibleValues()" [cxAtMessage]="
                'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate
              " aria-expanded="true" attr.aria-label="{{
                'productFacetNavigation.ariaLabelShowLess' | cxTranslate
              }}" class="cx-action-link showToggleLess" [cxFocus]="{ key: 'moreorless' }">
              {{'common.search_nav_facetShowLess'|cxTranslate}}
            </button>
          }
          @if (
            state.maxVisible &&
            facet.values &&
            state.maxVisible > 0 &&
            state.maxVisible < facet.values.length
            ) {
<button (click)="increaseVisibleValues()" [cxAtMessage]="
                'productFacetNavigation.increaseOptionsVisibility' | cxTranslate
              " aria-expanded="false" attr.aria-label="{{
                'productFacetNavigation.ariaLabelShowMore' | cxTranslate
              }}" class="cx-action-link showToggleLess" [cxFocus]="{ key: 'moreorless' }">
              {{'common.search_nav_facetShowMore'|cxTranslate}}
            </button>
          }
        </div>
      </ng-container>
    </div>
  </div>
}
